export function bigNumberWithCommas(value: number | bigint) {
  return value.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1,');
}
